import React from 'react';
import { motion } from 'framer-motion';
const photos = [{
  src: 'https://cdn.magicpatterns.com/patterns/generated-images/3383ab30-ae67-45bd-b5d2-428549da86c2.jpg',
  label: 'Oficinas'
}, {
  src: 'https://cdn.magicpatterns.com/patterns/generated-images/acc2c696-c4ae-4fd2-b375-8dfe6d3f5948.jpg',
  label: 'Comercios'
}, {
  src: 'https://cdn.magicpatterns.com/patterns/generated-images/0e5a9d58-8d94-43f1-a345-4a5eaa77c4b0.jpg',
  label: 'Salud'
}, {
  src: 'https://cdn.magicpatterns.com/patterns/generated-images/a2b0c581-0c2e-4702-982d-16fb821cf4f7.jpg',
  label: 'Industria'
}];
const sectors = ['Oficinas', 'Comercios', 'Industria', 'Salud', 'Servicios', 'Atención al público', 'Equipos de trabajo', 'Trabajo remoto'];
export function WorkplacesSection() {
  return <section className="w-full py-20 md:py-28 px-4" data-id="element-290" data-mp="1hyqcifmsjkjz">
      <div className="max-w-6xl mx-auto" data-id="element-291" data-mp="1d7gpznwjgxcb">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-292" data-mp="1d6f6cv1gj2iz">
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-293" data-mp="3d5fbrnbg9z7i">
            No importa{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-294" data-mp="2z4cqhcsa4sxn">
              dónde trabajes
            </span>
          </h2>
          <p className="text-ink-soft text-base md:text-lg mt-5 max-w-2xl mx-auto leading-relaxed" data-id="element-295" data-mp="2p7zw0cowub1u">
            El estrés laboral no ocurre solamente frente a una computadora.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-296" data-mp="nfv9xhu3e7z1">
          {photos.map((p, i) => <motion.figure key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          delay: i * 0.05
        }} className="relative rounded-3xl overflow-hidden border border-line shadow-sm" data-id="element-297" data-mp="sfzm4vnywgjg" data-mpi={i}>
              <img src={p.src} alt={`Trabajo en ${p.label.toLowerCase()}`} className="w-full h-56 md:h-64 object-cover" data-id="element-298" data-mp="19nh5jgbvwb5e" />
              <figcaption className="absolute bottom-3 left-3 bg-white/90 backdrop-blur text-ink text-xs font-bold tracking-widest uppercase px-3 py-1.5 rounded-full" data-id="element-299" data-mp="zxxj60oypz5s">
                {p.label}
              </figcaption>
            </motion.figure>)}
        </div>

        <div className="flex flex-wrap items-center justify-center gap-2.5 mt-8" data-id="element-300" data-mp="1notirjzntynl">
          {sectors.map((s, i) => <span key={i} className="inline-flex items-center bg-white border border-line text-ink text-sm font-medium px-4 py-2 rounded-full shadow-sm" data-id="element-301" data-mp="36c376w38tnnu" data-mpi={i}>
              {s}
            </span>)}
        </div>

        <p className="text-center font-serif-italic text-rose text-lg md:text-xl mt-10 max-w-3xl mx-auto" data-id="element-302" data-mp="3fece7bzayywh">
          Las situaciones cambian. La necesidad de manejar mejor la presión, los
          límites y las relaciones sigue estando.
        </p>
      </div>
    </section>;
}